import React from "react";
import Image from "react-bootstrap/esm/Image";
import "../ProductsListGrid.css";
import { default as config } from "../config.json";
import MessageBox from "./MessageBox";

export default function ProductsListGrid(props) {
  const { products, setFeature, setFeatures, setProduct, isTabletOrMobile } =
    props;

  return (
    <div
      className="bg-white scrollbar scrollbar-primary"
      style={{
        overflow: "auto",
        overflowX: "hidden",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
        gap: "1rem",
        padding: "1rem",
        height: "100%",
        alignContent: "flex-start",
      }}
    >
      {products.map((p) => (
        <div
          key={p._id}
          className="product-grid-item"
          onClick={() => {
            if (p.features.length === 1) {
              setFeatures(p.features);
              setProduct(p);
              setFeature(p.features[0]);
            } else {
              setFeatures(p.features);
              setProduct(p);
              setFeature("");
            }
          }}
        >
          <div className="image-container">
            <Image
              src={p.image || config.default_image}
              alt={p.name}
              fluid
              className="product-grid-image"
            />
            <div className="product-grid-label">
              {p.features && p.features.length === 1 && (
                <span>{p.features[0].name + " "}</span>
              )}
              <span>{p.name}</span>{" "}
            </div>
          </div>
        </div>
      ))}

      {products.length === 0 && (
        <div className={isTabletOrMobile ? "p-2 mt-3" : "p-1 mt-1"}>
          <MessageBox variant="danger">Ürün Yok!</MessageBox>
        </div>
      )}
    </div>
  );
}
